import { InjectionToken } from '@angular/core';
import { Config } from './core/models/config.model';

export const APP_CONFIG = new InjectionToken<Config>('Application Config');
